"use client";

import { c as _c } from "react/compiler-runtime";
import { useDesktopAnimations } from "@/lib/breakpoints";
import Image from "next/image";
import Link from "next/link";
import { motion } from "framer-motion";
import { FaChevronRight, FaHome, FaEnvelope } from "react-icons/fa";
const ease = [0.17, 0.85, 0.438, 0.99] as const;
const hoverCircleClassName = "pointer-events-none absolute -top-[10%] -right-[130px] block h-[200px] w-[200px] rounded-full bg-white/20 transition-[right] duration-[1200ms] ease-[cubic-bezier(0.17,0.85,0.438,0.99)] group-hover:-right-[80px]";
const container = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.12,
      delayChildren: 0.15
    }
  }
};
const fadeUp = {
  hidden: {
    opacity: 0,
    y: 28
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.7,
      ease
    }
  }
};

/**
 * Premium 404 — matches site typography, CTAs, shapes, and motion.
 */
export default function NotFound() {
  const $ = _c(74);
  const desktopAnimations = useDesktopAnimations();
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div aria-hidden={true} className="pointer-events-none absolute inset-0 bg-[url('/images/shape/bg-light2.png')] bg-contain bg-center bg-repeat-x dark:hidden" />;
    t1 = <div aria-hidden={true} className="pointer-events-none absolute inset-0 bg-[url('/images/shape/dot_bg.png')] bg-left-top bg-repeat opacity-60 dark:opacity-30" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] !== desktopAnimations) {
    t2 = desktopAnimations ? {
      y: [0, -14, 0],
      rotate: [0, 6, 0]
    } : undefined;
    $[2] = desktopAnimations;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== desktopAnimations) {
    t3 = desktopAnimations ? {
      duration: 7,
      repeat: Infinity,
      ease: "easeInOut"
    } : undefined;
    $[4] = desktopAnimations;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Image src="/images/shape/shape-1.svg" alt="" width={110} height={110} className="h-[110px] w-[110px] opacity-70" />;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t2 || $[8] !== t3) {
    t5 = <motion.div aria-hidden={true} className="pointer-events-none absolute top-[18%] left-[6%] z-0 hidden md:block" animate={t2} transition={t3}>{t4}</motion.div>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== desktopAnimations) {
    t6 = desktopAnimations ? {
      y: [0, 16, 0],
      rotate: [0, -5, 0]
    } : undefined;
    $[10] = desktopAnimations;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== desktopAnimations) {
    t7 = desktopAnimations ? {
      duration: 8,
      repeat: Infinity,
      ease: "easeInOut"
    } : undefined;
    $[12] = desktopAnimations;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Image src="/images/shape/shape-2.svg" alt="" width={130} height={130} className="h-[130px] w-[130px] opacity-70" />;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t6 || $[16] !== t7) {
    t9 = <motion.div aria-hidden={true} className="pointer-events-none absolute right-[8%] bottom-[16%] z-0 hidden md:block" animate={t6} transition={t7}>{t8}</motion.div>;
    $[15] = t6;
    $[16] = t7;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== desktopAnimations) {
    t10 = desktopAnimations ? {
      y: [0, -18, 0],
      opacity: [0.35, 0.7, 0.35]
    } : undefined;
    $[18] = desktopAnimations;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== desktopAnimations) {
    t11 = desktopAnimations ? {
      duration: 5.5,
      repeat: Infinity,
      ease: "easeInOut"
    } : undefined;
    $[20] = desktopAnimations;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t10 || $[23] !== t11) {
    t12 = <motion.span aria-hidden={true} className="pointer-events-none absolute top-[28%] right-[18%] hidden h-3 w-3 rounded-full bg-[#673ab7]/30 md:block" animate={t10} transition={t11} />;
    $[22] = t10;
    $[23] = t11;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== desktopAnimations) {
    t13 = desktopAnimations ? {
      y: [0, 14, 0],
      opacity: [0.3, 0.65, 0.3]
    } : undefined;
    $[25] = desktopAnimations;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== desktopAnimations) {
    t14 = desktopAnimations ? {
      duration: 6.2,
      repeat: Infinity,
      ease: "easeInOut"
    } : undefined;
    $[27] = desktopAnimations;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t13 || $[30] !== t14) {
    t15 = <motion.span aria-hidden={true} className="pointer-events-none absolute bottom-[30%] left-[20%] hidden h-2.5 w-2.5 rounded-full bg-[#e60072]/35 md:block" animate={t13} transition={t14} />;
    $[29] = t13;
    $[30] = t14;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== desktopAnimations) {
    t16 = desktopAnimations ? {
      opacity: 0,
      scale: 0.92
    } : false;
    $[32] = desktopAnimations;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  let t18;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = {
      opacity: 1,
      scale: 1
    };
    t18 = {
      duration: 0.8,
      ease
    };
    $[34] = t17;
    $[35] = t18;
  } else {
    t17 = $[34];
    t18 = $[35];
  }
  let t19;
  if ($[36] !== desktopAnimations) {
    t19 = desktopAnimations ? {
      y: [0, -10, 0],
      rotate: [0, 1.5, 0, -1.5, 0]
    } : undefined;
    $[36] = desktopAnimations;
    $[37] = t19;
  } else {
    t19 = $[37];
  }
  let t20;
  if ($[38] !== desktopAnimations) {
    t20 = desktopAnimations ? {
      duration: 6,
      repeat: Infinity,
      ease: "easeInOut"
    } : undefined;
    $[38] = desktopAnimations;
    $[39] = t20;
  } else {
    t20 = $[39];
  }
  let t21;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <div className="absolute inset-0 rounded-[32px] bg-[linear-gradient(135deg,#c7ecff_0%,#f9efff_55%,#ffe2e2_100%)] shadow-[0_25px_50px_-20px_rgba(5,7,72,0.18)] dark:opacity-90" />;
    $[40] = t21;
  } else {
    t21 = $[40];
  }
  let t22;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <svg viewBox="0 0 200 200" className="relative z-[1] h-[70%] w-[70%]" aria-hidden={true}><rect x="42" y="52" width="116" height="88" rx="14" fill="none" stroke="#050748" strokeWidth="3.5" opacity="0.55" /><circle cx="62" cy="72" r="4" fill="#e60072" /><circle cx="76" cy="72" r="4" fill="#2196f3" /><circle cx="90" cy="72" r="4" fill="#673ab7" /><line x1="42" y1="86" x2="158" y2="86" stroke="#050748" strokeWidth="2" opacity="0.2" /><circle cx="72" cy="118" r="7" fill="#673ab7" /><circle cx="128" cy="118" r="7" fill="#2196f3" /><path d="M80 118 H98" stroke="#050748" strokeWidth="3" strokeLinecap="round" opacity="0.35" /><path d="M110 118 H120" stroke="#050748" strokeWidth="3" strokeLinecap="round" strokeDasharray="4 6" opacity="0.35" /></svg>;
    $[41] = t22;
  } else {
    t22 = $[41];
  }
  let t23;
  if ($[42] !== t19 || $[43] !== t20) {
    t23 = <motion.div animate={t19} transition={t20} className="relative mx-auto flex h-[160px] w-[160px] items-center justify-center sm:h-[200px] sm:w-[200px]">{t21}{t22}</motion.div>;
    $[42] = t19;
    $[43] = t20;
    $[44] = t23;
  } else {
    t23 = $[44];
  }
  let t24;
  if ($[45] !== t16 || $[46] !== t23) {
    t24 = <motion.div initial={t16} animate={t17} transition={t18} className="relative mb-6 md:mb-8">{t23}</motion.div>;
    $[45] = t16;
    $[46] = t23;
    $[47] = t24;
  } else {
    t24 = $[47];
  }
  const t25 = desktopAnimations ? "hidden" : false;
  let t26;
  if ($[48] !== desktopAnimations) {
    t26 = desktopAnimations ? {
      opacity: 0,
      scale: 0.72
    } : false;
    $[48] = desktopAnimations;
    $[49] = t26;
  } else {
    t26 = $[49];
  }
  let t27;
  let t28;
  if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = {
      opacity: 1,
      scale: 1
    };
    t28 = {
      duration: 0.85,
      ease
    };
    $[50] = t27;
    $[51] = t28;
  } else {
    t27 = $[50];
    t28 = $[51];
  }
  let t29;
  if ($[52] !== t26) {
    t29 = <motion.p initial={t26} animate={t27} transition={t28} className={"\n                mb-3 bg-[linear-gradient(to_right,#673ab7_0%,#2196f3_55%,#e60072_100%)]\n                bg-clip-text font-poppins text-[88px] font-bold leading-none\n                text-transparent sm:text-[120px] md:text-[140px]\n              "} aria-hidden={true}>404</motion.p>;
    $[52] = t26;
    $[53] = t29;
  } else {
    t29 = $[53];
  }
  let t30;
  let t31;
  let t32;
  if ($[54] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = <motion.span variants={fadeUp} className="mb-[15px] block font-sans text-[16px] font-normal uppercase leading-4 tracking-[0.5px] text-[#e60072]">Error</motion.span>;
    t31 = <motion.h1 variants={fadeUp} className="mb-[15px] font-poppins text-[32px] font-bold leading-[1.2] text-[#050748] md:text-[48px] dark:text-white">Page Not Found</motion.h1>;
    t32 = <motion.p variants={fadeUp} className="mx-auto mb-0 max-w-[560px] font-sans text-[16px] font-normal leading-7 text-[#6a6a8e] md:text-[17px] dark:text-gray-400">The page you are looking for doesn't exist, was moved, or is temporarily unavailable. Let's get you back on track.</motion.p>;
    $[54] = t30;
    $[55] = t31;
    $[56] = t32;
  } else {
    t30 = $[54];
    t31 = $[55];
    t32 = $[56];
  }
  let t33;
  if ($[57] === Symbol.for("react.memo_cache_sentinel")) {
    t33 = <Link href="/" className={"\n                  group relative inline-flex h-14 w-full items-center justify-center\n                  overflow-hidden rounded-full\n                  bg-[linear-gradient(to_right,#673ab7_0%,#2196f3_100%)]\n                  px-8 font-poppins text-[16px] font-normal text-white\n                  shadow-[0_10px_15px_0_rgba(56,0,189,0.2)]\n                  transition-[transform,box-shadow] duration-300\n                  ease-[cubic-bezier(0.17,0.85,0.438,0.99)]\n                  hover:-translate-y-1 hover:shadow-[0_16px_28px_0_rgba(56,0,189,0.28)]\n                  sm:w-auto\n                "}><FaHome aria-hidden={true} className="relative z-[1] mr-2 text-[14px] transition-transform duration-300 group-hover:-translate-x-0.5" /><span className="relative z-[1]">Back to Home</span><FaChevronRight aria-hidden={true} className="relative z-[1] ml-2 text-[12px] transition-transform duration-300 group-hover:translate-x-1" /><span className={hoverCircleClassName} aria-hidden={true} /></Link>;
    $[57] = t33;
  } else {
    t33 = $[57];
  }
  let t34;
  if ($[58] === Symbol.for("react.memo_cache_sentinel")) {
    t34 = <motion.div variants={fadeUp} className="mt-[30px] flex w-full flex-col items-stretch justify-center gap-3 sm:flex-row sm:items-center sm:gap-4">{t33}<Link href="/contact" className={"\n                  group relative inline-flex h-14 w-full items-center justify-center\n                  overflow-hidden rounded-full\n                  bg-[linear-gradient(to_right,#f92c8b_0%,#b02cd6_100%)]\n                  px-8 font-poppins text-[16px] font-normal text-white\n                  shadow-[0_10px_15px_0_rgba(175,0,202,0.2)]\n                  transition-[transform,box-shadow] duration-300\n                  ease-[cubic-bezier(0.17,0.85,0.438,0.99)]\n                  hover:-translate-y-1 hover:shadow-[0_16px_28px_0_rgba(175,0,202,0.28)]\n                  sm:w-auto\n                "}><FaEnvelope aria-hidden={true} className="relative z-[1] mr-2 text-[14px]" /><span className="relative z-[1]">Contact Support</span><span className={hoverCircleClassName} aria-hidden={true} /></Link></motion.div>;
    $[58] = t34;
  } else {
    t34 = $[58];
  }
  let t35;
  if ($[59] === Symbol.for("react.memo_cache_sentinel")) {
    t35 = <Link href="/web-development" className="font-semibold text-[#673ab7] underline-offset-2 hover:underline dark:text-[#90caf9]">Web Development</Link>;
    $[59] = t35;
  } else {
    t35 = $[59];
  }
  let t36;
  if ($[60] === Symbol.for("react.memo_cache_sentinel")) {
    t36 = <Link href="/app-development" className="font-semibold text-[#673ab7] underline-offset-2 hover:underline dark:text-[#90caf9]">App Development</Link>;
    $[60] = t36;
  } else {
    t36 = $[60];
  }
  let t37;
  if ($[61] === Symbol.for("react.memo_cache_sentinel")) {
    t37 = <motion.p variants={fadeUp} className="mt-8 font-sans text-[14px] leading-6 text-[#6a6a8e] dark:text-gray-500">Or explore{" "}{t35},{" "}{t36}, or{" "}<Link href="/blog" className="font-semibold text-[#673ab7] underline-offset-2 hover:underline dark:text-[#90caf9]">Blog</Link>.</motion.p>;
    $[61] = t37;
  } else {
    t37 = $[61];
  }
  let t38;
  if ($[62] !== t25 || $[63] !== t29) {
    t38 = <motion.div variants={container} initial={t25} animate="show" className="w-full">{t29}{t30}{t31}{t32}{t34}{t37}</motion.div>;
    $[62] = t25;
    $[63] = t29;
    $[64] = t38;
  } else {
    t38 = $[64];
  }
  let t39;
  if ($[65] !== t24 || $[66] !== t38) {
    t39 = <div className="relative z-10 mx-auto w-full max-w-[1200px] px-[15px]"><div className="mx-auto flex max-w-[870px] flex-col items-center text-center">{t24}{t38}</div></div>;
    $[65] = t24;
    $[66] = t38;
    $[67] = t39;
  } else {
    t39 = $[67];
  }
  let t40;
  if ($[68] !== t12 || $[69] !== t15 || $[70] !== t39 || $[71] !== t5 || $[72] !== t9) {
    t40 = <section className={"\n        relative overflow-hidden bg-white py-12 sm:py-16 lg:py-20\n        transition-colors duration-300\n        dark:bg-gray-950\n      "}>{t0}{t1}{t5}{t9}{t12}{t15}{t39}</section>;
    $[68] = t12;
    $[69] = t15;
    $[70] = t39;
    $[71] = t5;
    $[72] = t9;
    $[73] = t40;
  } else {
    t40 = $[73];
  }
  return t40;
}